export enum COUNTRY_CODE {
  BRAZIL = 'BRA',
  ARGENTINA = 'ARG',
  PERU = 'PER',
  CHILE = 'CHL',
  COLOMBIA = 'COL',
  ECUADOR = 'ECU',
  VENEZUELA = 'VEN'
};

// TODO: ainda nao sei se vai ser usado, mas é bom manter para o futuro
export enum COUNTRY_CODE_ISO_2 {
  BRAZIL = 'BR',
  ARGENTINA = 'AR',
  USA = 'US',
  PERU = 'PE',
  CHILE = 'CL',
  COLOMBIA = 'CO',
  ECUADOR = 'EC',
  VENEZUELA = 'VE'
};

export enum COUNTRY_CURRENCY {
  BRAZIL = 'BRL',
  ARGENTINA = 'ARS',
  USA = 'USD',
  PERU = 'PEN',
  CHILE = 'CLP',
  COLOMBIA = 'COP',
  ECUADOR = 'USD',
  VENEZUELA = 'VEF'
};

export enum COUNTRY_LANG {
  BRAZIL = 'pt-BR',
  ARGENTINA = 'es-AR',
  USA = 'en-US',
  PERU = 'es-PE',
  CHILE = 'es-CL',
  COLOMBIA = 'es-CO',
  ECUADOR = 'es-EC',
  VENEZUELA = 'es-VE'
};
